export default function StatusPill({
  value,
  className,
  icon,
}: Readonly<{
  value: string
  className?: string
  icon?: React.ReactNode
}>) {
  let status = 'unknown'
  if (value) {
    status = value.toLowerCase()
  }

  className = className ?? ''

  if (icon === undefined) {
    icon = <></> // @@TODO: Return null instead of <></> ?
  }
  // @@TODO: Rewrite to switch statement.
  if (status.startsWith('beschikbaar')) {
    className = 'bg-purple-100 text-purple-800'
  } else if (status.startsWith('bezig')) {
    className = 'bg-yellow-100 text-yellow-800'
  } else if (status.startsWith('retired')) {
    className = 'bg-red-100 text-red-800'
  } else if (status.startsWith('open')) {
    className = 'bg-blue-100 text-blue-800'
  } else {
    //For debugging
    //color = 'bg-gray-200 text-gray-700'
  }

  return (
    <div
      className={`${className} px-3 py-1 uppercase leading-wide flex justify-center font-bold text-xs rounded-full shadow-xs border border-gray-300 dark:border-gray-700`}
    >
      {icon}
      {status}
    </div>
  )
}
